import script from "./SalesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesPage.vue?vue&type=script&setup=true&lang=js"

import "./SalesPage.vue?vue&type=style&index=0&id=6a866f66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a866f66"]])

export default __exports__